import templates from './templates/index';
import Mustache from '../../../vendors/mustache';
import { forceLogout, openIframeAuth } from '../../ramblerId';
import sendPrimeAnalytics from '../../analytics';
import { checkIsMobile } from '../../helpers';

const container = document.body.querySelector('.js-personal');

const missClickListener = function({ target }) {
  const inside = target === container || container.contains(target);
  if (!inside) {
    container.classList.remove('is-opened');
  }
};

const closeProfileMenu = function() {
  container.classList.remove('is-opened');
};

const openProfileMenu = function() {
  container.classList.add('is-opened');
};

const onProfileMenuClick = function() {
  if (container.classList.contains('is-opened')) {
    closeProfileMenu();
  } else {
    openProfileMenu();
  }
};

const clickListener = function({ target }) {
  const { classList } = target;
  const actionLogIn = classList.contains('js-login');
  const actionLogOut = classList.contains('js-logout');
  const actionPersonalSub = classList.contains('js-personal-subscription');
  const actionPersonalAdvOff = classList.contains('js-personal-adv-off');
  const actionOpenProfileMenu = classList.contains('js-profile');
  const actionProfile = classList.contains('js-personal-account');
  if (actionLogIn) {
    sendPrimeAnalytics('click', 'login');
    openIframeAuth();
  } else if (actionLogOut) {
    forceLogout();
    closeProfileMenu();
  } else if (actionOpenProfileMenu) {
    onProfileMenuClick();
  } else if (actionProfile) {
    closeProfileMenu();
  }
  if (actionPersonalAdvOff) {
    sendPrimeAnalytics('click', 'disableAdv');
  }
  if (actionPersonalSub) {
    closeProfileMenu();
    sendPrimeAnalytics('click', 'profile');
  }
};

const renderLogIn = function(userState) {
  const profileHTML = Mustache.render(templates.authorized, userState);
  if (container) container.innerHTML = profileHTML;
};

const renderLogOut = function(userState) {
  const logoutHTML = Mustache.render(templates.unauthorized, userState);
  if (container) container.innerHTML = logoutHTML;
};

if (container && !checkIsMobile()) {
  container.addEventListener('click', clickListener);
}

document.body.addEventListener('click', function(e) {
  missClickListener(e);
});

const sendShowProfileAnalyticsOnce = (state) => {
  if (!sendShowProfileAnalyticsOnce.alreadySent) {
    const isNotAuthorized = state.isAuthorized === false;
    if (isNotAuthorized) {
      sendPrimeAnalytics('show', 'login');
    }
    if (state.hasSubscription === false || isNotAuthorized) {
      sendPrimeAnalytics('show', 'disableAdv');
    }
    sendShowProfileAnalyticsOnce.alreadySent = true;
  }
};

/**
 * В зависимости от того, авторизован ли пользователь,
 * рендерит соответствующую шапку
 * @param {*} state
 */
const renderDesktopAuthElsInHeader = function(state) {
  state.subscriptionLink = window.AdvDailyHelper.subscriptionLink;
  if (state.isAuthorized) {
    renderLogIn(state);
  } else {
    renderLogOut(state);
  }
  sendShowProfileAnalyticsOnce(state);
};

export default renderDesktopAuthElsInHeader;



// WEBPACK FOOTER //
// ./daily/assets/id/header/desktop/index.js